function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M69.966 30.716l-31.46 20.496L7.048 30.716.013 34.377 38.507 59.36 77 34.377l-7.034-3.661z",
  fill: "#555F6A"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M69.966 44.244L38.506 64.74 7.048 44.244.013 47.905l38.494 24.983L77 47.905l-7.034-3.661zM23.335 8.516l-7.005 3.726 10.81 6.995 6.814-4.147-10.619-6.574zM27.067 24.56l-10.97 6.678 7.574 4.936 10.671-6.906-7.275-4.707zM38.254 17.752l-6.91 4.205 7.149 4.626 6.858-4.438-7.097-4.393zM49.593 24.771l-6.95 4.497 10.673 6.905 7.16-4.665-10.883-6.736zM53.53 8.452l-10.956 6.67 6.967 4.312 11.115-7.192-7.125-3.79z",
  fill: "#555F6A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.493 31.954L27.807 38.87l10.686 6.962L49.18 38.87l-10.686-6.915zM11.774 14.666L0 20.849l11.907 7.66 10.956-6.668-11.089-7.175zM38.493.602L27.944 6.064l10.33 6.396 10.629-6.47L38.493.602zM65.211 14.665L53.783 22.06l10.868 6.728 12.336-7.94-11.776-6.183z",
  fill: "#555F6A"
});

function SvgRhombs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 66,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgRhombs;